<template>
  <BaseTemplate>
    <div class="purchase-class">
      <Title class="_title" :jpn="t('Xmarket出品リスト')" />
      <div class="search-container">
        <div class="search-bar">
          <input type="text" v-model="postParam.freeword" @change="search(1)" />
          <button class="search-button">
            🔍
          </button>
        </div>
      </div>
      <MarketNotice />
      <MarketHeader
        :selectType="selectType"
        @changeSaleType="changeSaleType"
        @changeCardType="changeCardType"
      />
      <!-- <p>{{ cardList }}</p> -->
      <div class="card-list">
        <MarketCardList
          v-if="cardList"
          :isMyList="true"
          :cardList="cardList.list"
          :currentUser="userDetail"
          :cardListTitle="t('検索結果')"
          @refreshList="refresh"
          @handlePriceChange="handlePriceChange"
        />
        <BoxPager
          v-if="
            cardList.page &&
              cardList.page.pages &&
              cardList.page.pages.length > 1
          "
          class="box-pager"
          :totalPageCount="cardList.page.all_page"
          :currentPageCount="cardList.page.page"
          :dispBoxCount="cardList.page.pages.length"
          :pages="cardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
      <CommonOverlay
        v-if="showCardDetail"
        class="overlay_conf"
        @handleOverlayClick="closeModal"
      >
        <div @click.stop>
          <CommonModal @click.stop class="modal market-modal">
            <div class="card-info">
              <div class="card-info-text">
                <MarketCardList
                  :cardList="[popupCardData]"
                  :isHistory="false"
                  :isMyList="true"
                  :currentUser="userDetail"
                  :oneSheet="true"
                  :hideButtons="true"
                />
              </div>
              <div class="text-box">
                <TextBox
                  class="text-box"
                  type="number"
                  v-model="price"
                  :placeholder="t('販売価格を入力してください')"
                />
                <span :class="{ abroad: userAbroad }">
                  {{ t('円') }}
                </span>
              </div>
              <ErrorMessage
                v-if="errorMessageCard || errorMessageMarket || errorMessageParam"
                class="error-message"
                :message="errorMessageCard || errorMessageMarket || errorMessageParam"
              />
            </div>
            <div class="button-area">
              <div class="price-info">
                {{ formatPriceMessage(popupCardData.min_price) }}
              </div>
              <BuyButton
                :isArrow="false"
                :text="t('販売価格を更新する')"
                @handleSquareBtnClick="submitPriceChange"
              />
            </div>
          </CommonModal>
        </div>
      </CommonOverlay>
    </div>
  </BaseTemplate>
</template>

<script>
import { separateCharacterNumber } from '@/common/util/format';
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import MarketCardList from '@/components/organisms/MarketCardList.vue';
import Title from '@/components/molecules/Title02.vue';
import MarketHeader from '@/components/molecules/Header/MarketMyListHeader.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import MarketNotice from '@/components/atoms/MarketNotice.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'Market',
  mixins: [t],
  components: {
    BaseTemplate,
    Title,
    MarketCardList,
    BoxPager,
    MarketHeader,
    MarketNotice,
    CommonOverlay,
    CommonModal,
    BuyButton,
    TextBox,
    ErrorMessage,
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },
  data() {
    return {
      errorMessage: {},
      showCardDetail: false,
      popupCardData: {},
      price: '',
      errorMessageParam: null,
      errorMessageCard: null,
      errorMessageMarket: null,
      pageNumber: 1,
      postParam: {
        freeword: '',
        type: 1,
        sale_type: 0,
        card_type: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      marketList: 'market/resultMarketMyList',
      selectType: 'cardType/cardTypeList',
      userDetail: 'user/currentUserDetail',
      currentUser: 'user/currentUser',
      myListCardType: 'market/myListCardType',
      resultMarketPriceChange: 'market/resultMarketPriceChange',
    }),
    cardList() {
      if (this.marketList) {
        return this.marketList;
      }
      return [];
    },
    userAbroad() {
      if (this.currentUser) {
        return this.currentUser.language_id !== 1;
      }
      return false;
    },
  },
  watch: {
    resultMarketPriceChange(newResult) {
      if (!newResult) {
        return;
      }
      if ((newResult.state !== 200) || (newResult.errors && Object.keys(newResult.errors).length > 0)) {
        this.errorMessageParam = newResult.errors?.param?.[0] || null;
        this.errorMessageCard = newResult.errors?.card?.[0] || null;
        this.errorMessageMarket = newResult.errors?.market?.[0] || null;
        return;
      }

      this.showCardDetail = false;
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.price = '';
      this.refresh();
    },
  },
  created() {
    // storeからcard_typeを取得して設定
    if (this.myListCardType) {
      this.postParam.card_type = this.myListCardType;
    }
    this.$store.dispatch('market/my_list', {
      pageNumber: this.pageNumber,
      postParam: this.postParam,
    });
    this.$store.dispatch('cardType/setCardTypeList');
  },
  methods: {
    changeCurrentPageCount(page) {
      this.pageNumber = page;
      this.search(page);
    },
    changeSaleType(mode) {
      this.postParam.sale_type = mode;
      this.search();
    },
    changeCardType(mode) {
      this.postParam.card_type = mode;
      this.search();
    },
    search(page = this.pageNumber) {
      this.pageNumber = page;
      this.$store.dispatch('market/my_list', {
        pageNumber: this.pageNumber,
        postParam: this.postParam,
      });
    },
    refresh() {
      // 表の再取得
      this.search(this.pageNumber);
      // ユーザー詳細の更新
      this.$store.dispatch('user/setCurrentUser');
    },
    handlePriceChange(cardItem) {
      this.popupCardData = cardItem || {};
      this.price = cardItem?.price ? String(cardItem.price) : '';
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
      this.showCardDetail = true;
    },
    closeModal() {
      this.showCardDetail = false;
      this.errorMessageParam = null;
      this.errorMessageCard = null;
      this.errorMessageMarket = null;
    },
    submitPriceChange() {
      if (!this.popupCardData || !this.popupCardData.id) {
        return;
      }
      const postParams = {
        market_id: this.popupCardData.id,
        price: this.price,
      };
      this.$store.dispatch('market/price_change', { postParam: postParams });
    },
    formatPriceMessage(min) {
      if (!min) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '{min}円以上の価格で出品できます。';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{min}', this.$options.filters.comma(min));
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-class {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  color: #042859;
  ._title {
    margin-top: 20px;
    max-width: 900px;
    margin: 0 auto;
  }
  //検索バーとフィルター___________________
  .search-container {
    max-width: 900px;
    // background-color: #f0f0f0;
    margin: 0 auto;
    width: 90%;
    padding: 20px 20px 10px 20px;
    text-align: center;
    .search-bar {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 5px 10px;
      position: relative;
      border: 1px solid $gray2;
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 16px;
      }
      .search-button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
  //カード一覧_____________________________
  .card-container {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
  }
  // フッターメニュー
  .footer-menu {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    width: 90%;
    position: fixed;
    bottom: 97px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    z-index: 1000;
    @media screen and (max-width: $tabletWidth) {
      bottom: 66px;
      gap: 2px;
      width: 97%;
    }
    .menu-button-left,
    .menu-button-right {
      flex: 1;
      text-align: center;
      font-weight: bold;
      padding: 10px;
      font-size: 18px;
      border: none;
      cursor: pointer;
      outline: none;
      transition: all 0.3s ease-in-out;
      border-radius: 10px;
      box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: $tabletWidth) {
        padding: 4px;
      }
    }
    .menu-button-left {
      color: white;
      background: linear-gradient(
        to bottom,
        #3fcdff,
        #1085d0
      ); // 青色グラデーション
      &:hover {
        background: linear-gradient(to bottom, #49a8ff, #0d75bb);
      }
    }
    .menu-button-right {
      color: #323232;
      background: linear-gradient(
        to bottom,
        #fff100,
        #ff9800
      ); // 黄色グラデーション
      &:hover {
        background: linear-gradient(to bottom, #ffd04a, #ff8f00);
      }
    }
  }
  .overlay_conf{
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .market-modal {
      border: none;
      box-shadow:  0 0px 20px rgba(0, 0, 0, 1.0);
      border-radius: 10px;
      max-width: 700px;
      min-width: 500px;
      max-height: 90%;
      overflow-y: auto;
      padding: 20px;
      position: relative;
      @media screen and (max-width: 530px) {
        min-width: 90vw;
      }
      .card-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
        .card-info-text {
          margin-top: 10px;
        }
        .text-box {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 230px;
          margin: 0 auto; // 親幅に対して中央に配置
          font-size: 18px;
          position: relative;
          span {
            position: absolute;
            right: -25px; // inputの右端内側に表示
            pointer-events: none;
            font-weight: bold;
            &.abroad {
              right: -38px;
            }
          }
        }
      }
      .button-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        button{
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          border-radius: 50px;
          border: none;
          font-size: 16px;
          margin-bottom: 10px;
          width: auto;
        }
        .price-info {
          font-size: 14px;
          color: #666;
          text-align: center;
          .tax-info {
            color: $red;
          }
        }
      }
    }
  }
}
</style>
